export default {
  title: "Календарь подготовки к выставке:",
  titleInEvent: "Календарь подготовки к выставке:",

  company: "Дополните профиль компании",
  order: "Разместите заявку на публикацию в каталоге не позднее {date}",
  pass: "Оформите  пропуска не позднее {date}",
  addServices: "Оформите заказ дополнительных услуг не позднее {date}",
  selectEvent: "Выберите выставку",
  sendApplication: "Отправьте заявку на участие",
  contract: "Заключите договор (код участника)"
};
